var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.9999,
    cy: 26.9999,
    r: 25.9999,
    stroke: "#FFF8E8",
    strokeWidth: 1.39293
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4613 17.4141L30.9447 16.5996H27.8185V23.9356L27.8079 31.1012C27.8132 31.1544 27.8185 31.213 27.8185 31.2662C27.8185 33.0603 26.3593 34.5243 24.5592 34.5243C22.7591 34.5243 21.2999 33.0656 21.2999 31.2662C21.2999 29.4721 22.7591 28.0082 24.5592 28.0082C24.932 28.0082 25.2942 28.0774 25.6297 28.1945V24.617C25.2835 24.5584 24.9267 24.5265 24.5592 24.5265C20.8472 24.5318 17.8223 27.5556 17.8223 31.2715C17.8223 34.9874 20.8472 38.0113 24.5645 38.0113C28.2819 38.0113 31.3068 34.9874 31.3068 31.2715V22.7484C32.6542 24.0953 34.3957 25.4102 36.3236 25.8308V22.1735C34.2306 21.2471 32.1483 18.5108 31.4613 17.4141Z",
    stroke: "#FFF8E8",
    strokeWidth: 1.39293
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.8bb1367a94c5fb57a435389cd6dde366.svg";
export { ForwardRef as ReactComponent };